export default __webpack_public_path__ + "static/media/whatsapp-icon.feeec508.svg";